module.exports = __webpack_public_path__ + "img/a12.5f4c19bd.png";